import { Injectable, inject } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { merge, throwError } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

import type { Candidate } from '@core/candidate-types';
import type { MailboxConvertData } from '@core/mailbox-types';
import { generateUuid } from '@core/utils-legacy';

import { MailboxThreadsActions } from './mailbox-threads.store';

@Injectable({ providedIn: 'root' })
export class MailboxConvertService {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  public convertCandidate(convertData: MailboxConvertData): Observable<Candidate> {
    const uuid = generateUuid();
    this.store.dispatch(
      MailboxThreadsActions.convert({ payload: { data: convertData, correlationId: uuid } }),
    );
    return merge(
      this.actions$.pipe(
        ofType(MailboxThreadsActions.convertSuccess),
        filter(({ payload }) => payload.correlationId === uuid),
        take(1),
        map(({ payload }) => payload.data),
      ),
      this.actions$.pipe(
        ofType(MailboxThreadsActions.convertFailed),
        filter(({ payload }) => payload.correlationId === uuid),
        take(1),
        switchMap(({ payload }) => throwError(payload.error)),
      ),
    );
  }
}
